<template>
<nav class="navbar navbar-expand-md fixed-top navbar-dark bg-dark" aria-label="Main navigation">

  <div class="navbar-collapse offcanvas-collapse" :class="{ 'open': topbarToggled }" id="topNavbar">

    <!-- Rechts ausgerichtete UL -->
    <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
      <li class="nav-item">
        <router-link to="/" class="nav-link">
          <span class="d-md-none d-xl-inline">Login</span>
        </router-link>
      </li>

      <li class="nav-item">
        <a href="#" class="nav-link" @click.prevent="loginAsDemo">
          <span class="d-md-none d-xl-inline">Demozugang</span>
        </a>
      </li>
    </ul>

  </div>

</nav>
</template>


<script>
import { performDemoLogin } from '@/utils/authService'

export default {
  name: 'TopbarNoAuth',
  methods: {
    async loginAsDemo() {
      console.log('Demo-Login gestartet')

      try {
        await performDemoLogin(this.$store)

        // Zum Dashboard weiterleiten
        this.$router.push('/dashboard')

      } catch (error) {
        console.error('Fehler beim Demo-Login:', error)
        // Bei Fehler zum normalen Login weiterleiten
        this.$router.push('/')
      }
    }
  }
}
</script>
<style>

</style>
